import {
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger
} from "@/components/ui/context-menu";
import { Input } from "@/components/ui/input";

const TooltipIcon: React.FC<
  React.ComponentProps<"div"> & {
    rightClickedElement: HTMLElement;
  }
> = ({ rightClickedElement }) => {
  const tooltip = rightClickedElement.parentElement?.querySelector(
    "div.tooltiptext"
  ) as HTMLDivElement | null;
  const tooltipText = tooltip?.innerText ?? "";

  return (
    <>
      <ContextMenuSub>
        <ContextMenuSubTrigger>تولتیپ</ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <Input
            placeholder="placeholder..."
            defaultValue={tooltipText}
            onChange={(e) => {
              if (!tooltip) return;
              tooltip.textContent = e.target.value.trim();
            }}
          />
        </ContextMenuSubContent>
      </ContextMenuSub>
    </>
  );
};
export default TooltipIcon;
